import { Locale, type LocalizedString } from "../Locale.js";

export const helpdeskUrlMap: LocalizedString = {
	[Locale.cs]: "https://support.vertiflex.eu/?lang=cs",
	[Locale.en]: "https://support.vertiflex.eu/?lang=en_GB",
};
